/**
 * National Provider Identifier (NPI) validation.
 *
 * An NPI — individual (Type 1) or organizational/group (Type 2) — is exactly
 * 10 digits. Shared so the clinic Group NPI field validates identically to any
 * other NPI input. Checksum validation is intentionally out of scope: a
 * well-formed-but-wrong NPI is rejected loudly by the payer/HETS at check time.
 */
export const isValidNpi = (v: string): boolean => /^\d{10}$/.test(v)
